import {
  presetsInitError,
  presetsInitFetch,
  presetsInitSuccess,
  presetsPromptDismiss,
  presetsPromptShow,
  presetsPromptSubmit,
  presetsSaveSuccess,
  presetsLoadGalleriesSuccess,
} from '../actions';

export default {
  [presetsInitFetch.toString()]: state => ({
    ...state,
    presetsStatus: 'fetching',
  }),
  [presetsInitSuccess.toString()]: (state, action) => ({
    ...state,
    presetsInit: {
      ...action.payload,
      published: false,
    },
    presetsStatus: 'idle',
  }),
  [presetsInitError.toString()]: state => ({
    ...state,
    presetsStatus: 'error',
  }),
  [presetsSaveSuccess.toString()]: state => ({
    ...state,
    presetsInit: undefined,
    presetsStatus: 'uninitialized',
  }),
  [presetsPromptShow.toString()]: (state, action) => ({
    ...state,
    presetsPrompt: {
      type: action.payload.type,
      status: 'shown',
    },
  }),
  [presetsPromptSubmit.toString()]: (state, action) => ({
    ...state,
    presetsPrompt: {
      type: action.payload.type,
      status: 'submitting',
    },
  }),
  [presetsPromptDismiss.toString()]: state => ({
    ...state,
    presetsPrompt: {},
  }),
  [presetsLoadGalleriesSuccess.toString()]: (state, action) => ({
    ...state,
    presetsInit: {
      ...state.presetsInit,
      ...action.payload,
    },
  }),
};
